import { defineStore } from 'pinia';
import {IUserMatriculeByCompany} from "@/models/companyMatricule/IUserMatriculeByCompany";

interface ISelectedCompany {
    uuid: string;
    name: string;
}

export const useCompanyMatriculeStore = defineStore('companyMatricule', {
    state: () => ({
        selectedMatricule: null as IUserMatriculeByCompany | null,
        selectedCompany: null as ISelectedCompany | null,
    }),

    actions: {
        setSelectedMatricule(matricule: IUserMatriculeByCompany) {
            this.selectedMatricule = matricule;
        },

        clearSelectedMatricule() {
            this.selectedMatricule = null;
        },

        setSelectedCompany(company: ISelectedCompany) {
            this.selectedCompany = company;
        },

        clearSelectedCompany() {
            this.selectedCompany = null;
        },

        clearAll() {
            this.selectedMatricule = null
            this.selectedCompany = null
        },
    },

    getters: {
        getSelectedMatricule: (state) => state.selectedMatricule,
        getSelectedCompany: (state) => state.selectedCompany,
    },

    persist: {
        storage: sessionStorage,
    },
});